import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import { makeArray } from "discourse/lib/helpers";
import MultiSelectComponent from "select-kit/components/multi-select";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const WatchedWords = dt7948.c(class WatchedWords extends MultiSelectComponent {
  get content() {
    return makeArray(this.value).map(x => this.defaultItem(x, x));
  }
  static {
    dt7948.n(this.prototype, "content", [computed("value.[]")]);
  }
}, [pluginApiIdentifiers("watched-words"), selectKitOptions({
  autoInsertNoneItem: false,
  fullWidthOnMobile: true,
  allowAny: true,
  none: "admin.watched_words.form.words_or_phrases"
}), classNames("watched-word-input-field")]);
export default WatchedWords;